exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.widget-card[data-v-7a15a737] {\n    z-index: 1030;\n    width: 335px;\n    padding: 10px;\n    margin: 5px 5px 5px 5px;\n    min-height: 150px;\n}\n\n\n\n\n\n", ""]);

// exports
